import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DeviceConfigurerServiceSharedModule } from '../shared';

import { HOME_ROUTE, HomeComponent } from './';
import {SellerDashboardModule} from '../dashboard/seller-dashboard/seller-dashboard.module';


@NgModule( {
    imports: [
        DeviceConfigurerServiceSharedModule,
        RouterModule.forRoot( [ HOME_ROUTE ], { useHash: true } ),
        SellerDashboardModule
    ],
    declarations: [
        HomeComponent,
    ],
    entryComponents: [],
    providers: [],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
} )
export class DeviceConfigurerServiceHomeModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/home.module.ts